const moment = require("moment");
const thousands = require("venuescanner-js/utils/formatter/thousands");
const offerDates = (offer) => {
  if (!offer || !offer.dates) return "";
  const dates = offer.dates.split("-").map((date) => date.trim());
  const hours = offer.hours.split("-").map((time) => time.trim());
  // console.log({ offer, dates })
  const moreThanOneDay = dates[0] !== dates[1];
  if (moreThanOneDay) {
    const fromDay = moment(dates[0], "DD/MM/YYYY");
    const toDay = moment(dates[1], "DD/MM/YYYY");
    const sameYear = fromDay.format("YYYY") === toDay.format("YYYY");
    const sameMonth = fromDay.format("MM") === toDay.format("MM");
    const fromFormat = sameYear
      ? sameMonth
        ? "ddd Do"
        : "ddd Do MMM"
      : "ddd Do MMM YY";
    const toFormat = "ddd Do MMM YY";
    return `${fromDay.format(fromFormat)} - ${toDay.format(toFormat)}`;
  } else {
    const fromDay = moment(dates[0], "DD/MM/YYYY");
    // console.log(fromDay, fromDay.format('ddd Do MMM YY'))
    return fromDay.format("ddd Do MMM YY");
  }
};

const offerTimes = (offer) => {
  if (!offer || !offer.dates) return "";
  const dates = offer.dates.split("-").map((date) => date.trim());
  const hours = offer.hours.split("-").map((time) => time.trim());
  const allDay = hours[0] === "00:00" && hours[1] === "23:59";
  const moreThanOneDay = dates[0] !== dates[1];
  const fromDay = moment(`${dates[0]} ${hours[0]}`, "DD/MM/YYYY hh:mm");
  const fromFormat = fromDay.format("mm") === "00" ? "ha" : "h:mma";
  const toDay = moment(`${dates[1]} ${hours[1]}`, "DD/MM/YYYY hh:mm");
  const toFormat = toDay.format("mm") === "00" ? "ha" : "h:mma";
  if (moreThanOneDay) {
    const days = toDay.diff(fromDay, "days");
    if (allDay) {
      return `all ${days} days`;
    } else {
      return `${fromDay.format(`${fromFormat} ddd Do`)} to ${toDay.format(
        `${toFormat} ddd Do`
      )}`;
    }
  } else {
    return `${fromDay.format(`${fromFormat}`)} to ${toDay.format(
      `${toFormat}`
    )}`;
  }
};
const offerLayout = (layout) => {
  return layout || "Not specified";
};
const offerPrice = (price) => {
  return price && !isNaN(price) ? thousands(price) : "tbc";
};
const offerEvent = (eventType) => {
  return eventType || "Not specified";
};
const offerCapacity = (capacity) => {
  return capacity || "tbc";
};

module.exports = {
  offerDates,
  offerTimes,
  offerLayout,
  offerPrice,
  offerEvent,
  offerCapacity,
};
